import styled from 'styled-components';
import Header from './Header';

const SectionHeader = styled(Header)`
  display: flex;
  align-items: center;
  color: ${(p) => p.theme.accent.primary};

  :after {
    content: '';
    flex: 1;
    border-bottom: 2px solid ${(p) => p.theme.accent.primary}20;
  }

  :after {
    margin-left: 18px;
  }

  @media screen and (max-width: 767px) {
    :after {
      margin-left: 10px;
    }
  }
`;

export default SectionHeader;
